(function() {
  'use strict';

  const PETRI_DISH_URL = 'https://cdn.shopify.com/s/files/1/0927/0188/4787/files/Petri_Dish_image_JPEG.jpg?v=1773867093';

  const CLINICAL_DATA = {
    glplus10: {
      intro: 'Formulated for your body. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">GLPLUS+ 10-in-1</span> formula. Here is what they found:',
      sections: [
        {
          label: 'SHOWN TO SUPPORT NATURAL GLP-1 ACTIVATION<sup class="cs-mark">*</sup>',
          stats: [
            { number: '35%', desc: 'reduction in fasting blood glucose observed in subjects taking Berberine HCl in a 3-month clinical trial<sup class="cs-mark">*</sup>' },
            { number: '44.7%', desc: 'reduction in insulin resistance (HOMA-IR) in diabetic subjects supplemented with Berberine<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'CLINICALLY SHOWN TO SUPPORT METABOLIC HEALTH<sup class="cs-mark">*</sup>',
          stats: [
            { number: '1 Billion CFU', desc: 'probiotic blend clinically associated with improved gut microbiome diversity and digestive function<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    glplus20: {
      intro: 'Formulated for your gut. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">GLPLUS+ 20-in-1</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT GUT HEALTH<sup class="cs-mark">*</sup>',
          stats: [
            { number: '2 Billion CFU', desc: 'dual probiotic + postbiotic blend shown to support healthy gut microbiome balance and immune function<sup class="cs-mark">*</sup>' },
            { number: '6', desc: 'digestive enzymes (including Bromelain and Protease) shown to improve nutrient absorption and reduce bloating<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT DIGESTIVE COMFORT<sup class="cs-mark">*</sup>',
          stats: [
            { number: '3x', desc: 'prebiotic fibers (Oat, Inulin, Psyllium) clinically associated with increased beneficial gut bacteria and regularity<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    mag13: {
      intro: 'Formulated for total absorption. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">MAGPLUS+ 13-in-1</span> formula. Here is what they found:',
      sections: [
        {
          label: 'SHOWN TO DELIVER SUPERIOR BIOAVAILABILITY<sup class="cs-mark">*</sup>',
          stats: [
            { number: '13', desc: 'forms of magnesium including Glycinate, L-Threonate, and Taurate — each clinically studied for targeted tissue absorption<sup class="cs-mark">*</sup>' },
            { number: '900 mg', desc: 'total magnesium complex per serving, delivered via liposomal technology for enhanced cellular uptake<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'CLINICALLY ASSOCIATED WITH IMPROVED RECOVERY<sup class="cs-mark">*</sup>',
          stats: [
            { number: '48%', desc: 'of adults are estimated to be magnesium deficient — supplementation has been shown to improve sleep quality, muscle recovery, and stress response<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    mag7: {
      intro: 'Formulated for deep rest. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">MAGPLUS+ 7-in-1</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT RELAXATION &amp; SLEEP<sup class="cs-mark">*</sup>',
          stats: [
            { number: '200 mg', desc: 'L-Theanine per serving — shown in clinical trials to promote alpha brain wave activity and reduce stress without drowsiness<sup class="cs-mark">*</sup>' },
            { number: '50 mg', desc: 'Apigenin — the compound clinically studied for its ability to bind GABA receptors and support natural sleep onset<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO REDUCE STRESS MARKERS<sup class="cs-mark">*</sup>',
          stats: [
            { number: '100 mg', desc: 'Chamomile Extract (10:1) — associated with reduced anxiety scores in randomized, placebo-controlled trials<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    uro: {
      intro: 'Formulated for cellular renewal. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">UROPLUS+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO BOOST MITOCHONDRIAL HEALTH<sup class="cs-mark">*</sup>',
          stats: [
            { number: '12%', desc: 'improvement in muscle strength observed in a randomized, placebo-controlled trial of Urolithin A in middle-aged adults<sup class="cs-mark">*</sup>' },
            { number: '15%', desc: 'increase in CD8+ fatty acid oxidation capacity — a marker of improved cellular energy and immune resilience<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT HEALTHY AGING<sup class="cs-mark">*</sup>',
          stats: [
            { number: '7', desc: 'NAD+ precursors and longevity compounds including Nicotinamide Riboside and Resveratrol — clinically associated with improved cellular repair and reduced inflammation<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    maca: {
      intro: 'Formulated for daily vitality. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">MACAPLUS+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT ENERGY &amp; BALANCE<sup class="cs-mark">*</sup>',
          stats: [
            { number: '1,000 mg', desc: 'Organic Black Maca Root (40:1 extract) — clinically associated with improved energy, stamina, and hormonal balance in both men and women<sup class="cs-mark">*</sup>' },
            { number: '27.9%', desc: 'reduction in serum cortisol levels observed in adults supplemented with Ashwagandha root extract in a 60-day placebo-controlled trial<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT HORMONAL HEALTH<sup class="cs-mark">*</sup>',
          stats: [
            { number: '100 mg', desc: 'Fenugreek Seed Extract (50% Saponins) — associated with improved testosterone levels and libido in clinical studies<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    soursop: {
      intro: 'Formulated for the gut. <em>Rooted in tradition.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers built <span class="cs-green">SOURSOP BITTERS+</span> on the botanicals of Caribbean and West African bitters tradition. Here is what is in every spoonful:',
      sections: [
        {
          label: 'TRADITIONAL DIGESTIVE BITTERS AT A REAL SERVING<sup class="cs-mark">*</sup>',
          stats: [
            { number: '3,100 mg', desc: '16-botanical soursop bitters blend per 34 ml serving \u2014 graviola soursop leaf, ginger, garlic and cinnamon, the bitter and warming botanicals traditionally used to support comfortable digestion and occasional regularity<sup class="cs-mark">*</sup>' },
            { number: '16', desc: 'botanicals in one bottle, versus the six to ten found in most soursop bitters \u2014 including Irish sea moss, black seed, moringa, neem and turmeric with black pepper for absorption<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'MORE PER BOTTLE, NOTHING ADDED<sup class="cs-mark">*</sup>',
          stats: [
            { number: '15', desc: 'full 34 ml servings from a 16.9 fl oz bottle \u2014 not a 2 oz dropper gone in a week \u2014 at a fraction of the cost per ounce<sup class="cs-mark">*</sup>' },
            { number: '0 g', desc: 'added sugar. Naturally orange-flavored and stevia-sweetened, so it can be taken straight; no fillers, no proprietary blends, every ingredient disclosed<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    zeolite: {
      intro: 'Formulated for deep detox. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">ZEOLITE+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT HEAVY METAL DETOXIFICATION<sup class="cs-mark">*</sup>',
          stats: [
            { number: '1,000 mg', desc: 'Activated Zeolite (Clinoptilolite) complex — clinically studied for its ability to selectively bind and remove heavy metals from the body without depleting essential minerals<sup class="cs-mark">*</sup>' },
            { number: 'NAC', desc: '(N-Acetylcysteine) — shown to increase glutathione production, the body\'s master antioxidant, supporting liver detoxification and cellular defense<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT LIVER &amp; GUT CLEANSING<sup class="cs-mark">*</sup>',
          stats: [
            { number: 'Milk Thistle', desc: 'clinically associated with hepatoprotective effects and improved liver enzyme markers in multiple controlled trials<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    test: {
      intro: 'Formulated for peak performance. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">TESTPLUS+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT TESTOSTERONE PRODUCTION<sup class="cs-mark">*</sup>',
          stats: [
            { number: '700 mg', desc: 'Tongkat Ali (200:1 Extract) — meta-analysis of clinical trials confirms significant increases in total testosterone levels in men. Studies show up to 61% increase in testosterone in male subjects over 5 weeks<sup class="cs-mark">*</sup>' },
            { number: '300 mg', desc: 'Fadogia Agrestis (30:1) — associated with increased testosterone and improved reproductive function in preclinical studies<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT STRENGTH &amp; VITALITY<sup class="cs-mark">*</sup>',
          stats: [
            { number: '75.6%', desc: 'reduction in anxiety scores and significant cortisol reduction observed in subjects supplemented with Ashwagandha in a double-blind, placebo-controlled trial<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    viva: {
      intro: 'Formulated for feminine wellness. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">VIVA LA V+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT PH &amp; HORMONAL BALANCE<sup class="cs-mark">*</sup>',
          stats: [
            { number: '1 Billion CFU', desc: 'Bacillus Coagulans — a shelf-stable probiotic clinically shown to survive stomach acid and support vaginal and digestive health<sup class="cs-mark">*</sup>' },
            { number: 'Chaste Berry', desc: '(10:1 Extract) — clinically associated with improved PMS symptoms, hormonal regulation, and cycle regularity in women<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT COMFORT &amp; RESILIENCE<sup class="cs-mark">*</sup>',
          stats: [
            { number: '600 mg equiv.', desc: 'Slippery Elm Bark (20:1 extract) — traditionally used and clinically associated with soothing mucosal membranes and supporting gut lining integrity<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    glo: {
      intro: 'Formulated for radiant defense. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">GLOPLUS+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO BOOST THE BODY\'S MASTER ANTIOXIDANT<sup class="cs-mark">*</sup>',
          stats: [
            { number: '1,150 mg', desc: 'Liposomal Glutathione Support Complex — L-Glutathione and NAC are clinically shown to raise intracellular glutathione levels, the body\'s primary defense against oxidative stress<sup class="cs-mark">*</sup>' },
            { number: '182%', desc: 'Daily Value of Selenium per serving — an essential mineral clinically shown to support glutathione peroxidase activity and thyroid function<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT SKIN, LIVER &amp; IMMUNE HEALTH<sup class="cs-mark">*</sup>',
          stats: [
            { number: '133%', desc: 'Daily Value of Vitamin C + Alpha Lipoic Acid — clinically associated with collagen synthesis, antioxidant recycling, and enhanced immune response<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    shilajit: {
      intro: 'Formulated for ancient strength. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">SHILAJITPLUS+</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT TESTOSTERONE &amp; ENERGY<sup class="cs-mark">*</sup>',
          stats: [
            { number: '800 mg', desc: 'Organic Black Shilajit (80% Fulvic Acid) — clinical studies show purified Shilajit significantly increased total testosterone, free testosterone, and DHEA-S levels in healthy volunteers over 90 days<sup class="cs-mark">*</sup>' },
            { number: '250 mg', desc: 'Ashwagandha (10% Withanolides) — associated with a 27.9% reduction in cortisol and significant improvements in stress resilience in a 60-day placebo-controlled trial<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT ADAPTOGENIC PERFORMANCE<sup class="cs-mark">*</sup>',
          stats: [
            { number: '100 mg', desc: 'Tongkat Ali (200:1) — meta-analysis confirms significant testosterone increases; studies show improved strength and reduced fatigue in older adults<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    },
    gummies: {
      intro: 'Formulated for daily GLP-1 support. <em>Clinically backed.</em>',
      paragraph: 'Our pharmacists, scientists, and researchers worked with third-party experts to study the <span class="cs-green">GLPLUS+ Gummies</span> formula. Here is what they found:',
      sections: [
        {
          label: 'CLINICALLY SHOWN TO SUPPORT GUT &amp; GLP-1 HEALTH<sup class="cs-mark">*</sup>',
          stats: [
            { number: '1 Billion TFU', desc: 'Akkermansia — a next-generation probiotic clinically shown to improve gut barrier function, reduce inflammation, and support metabolic health in overweight adults<sup class="cs-mark">*</sup>' },
            { number: 'Resveratrol', desc: 'clinically associated with improved insulin sensitivity and reduced oxidative stress in multiple randomized controlled trials<sup class="cs-mark">*</sup>' }
          ]
        },
        {
          label: 'SHOWN TO SUPPORT METABOLISM &amp; DIGESTION<sup class="cs-mark">*</sup>',
          stats: [
            { number: 'Turmeric + Ginger', desc: 'clinically shown to reduce inflammatory markers (CRP) and support digestive comfort in placebo-controlled studies<sup class="cs-mark">*</sup>' }
          ]
        }
      ]
    }
  };

  function getCopyKeyFromHandle(handle) {
    if (!handle) return null;

    const handleLower = handle.toLowerCase();

    // Product handle mapping
    if (handleLower.includes('glp-1-supplement') || handleLower.includes('gpllus-10-in-1') || handleLower.includes('glp-1-support-capsules')) {
      return 'glplus10';
    }
    if (handleLower.includes('20-in-1-gut') || handleLower.includes('glp-1-synbiotic')) {
      return 'glplus20';
    }
    if (handleLower.includes('13-in-1-magnesium')) {
      return 'mag13';
    }
    if (handleLower.includes('magplus-magnesium') || handleLower.includes('magplus-7-in-1')) {
      return 'mag7';
    }
    if (handleLower.includes('urolithin')) {
      return 'uro';
    }
    if (handleLower.includes('macaplus') || handleLower.includes('maca-complex')) {
      return 'maca';
    }
    if (handleLower.includes('soursop')) {
      return 'soursop';
    }
    if (handleLower.includes('zeolite') || handleLower.includes('8-in-1-zeolite')) {
      return 'zeolite';
    }
    if (handleLower.includes('testplus')) {
      return 'test';
    }
    if (handleLower.includes('vaginal-probiotic') || handleLower.includes('viva')) {
      return 'viva';
    }
    if (handleLower.includes('gloplus') || handleLower.includes('glo-liposomal')) {
      return 'glo';
    }
    if (handleLower.includes('shilajit')) {
      return 'shilajit';
    }
    if (handleLower.includes('glp-1-support-gummy') || handleLower.includes('akkermansia') || handleLower.includes('glp-1-gummies')) {
      return 'gummies';
    }

    // Bundle handle mapping
    if (handleLower.includes('glp-activate')) {
      return 'glplus10';
    }
    if (handleLower.includes('weight-loss') || handleLower.includes('complete-weight-loss')) {
      return 'glplus10';
    }
    if (handleLower.includes('metabolic-reset')) {
      return 'glplus10';
    }
    if (handleLower.includes('women-s-balance')) {
      return 'viva';
    }
    if (handleLower.includes('men-s-vitality')) {
      return 'test';
    }
    if (handleLower.includes('sleep-stress')) {
      return 'mag7';
    }
    if (handleLower.includes('skin-detox')) {
      return 'glo';
    }

    return null;
  }

  function buildSectionHTML(data) {
    let categoriesHTML = '';

    for (const section of data.sections) {
      let statsHTML = '';
      for (const stat of section.stats) {
        statsHTML += `
          <div class="cs-stat">
            <div class="cs-stat-number">${stat.number}</div>
            <div class="cs-stat-desc">${stat.desc}</div>
          </div>
        `;
      }

      categoriesHTML += `
        <div class="cs-category">
          <div class="cs-category-label">${section.label}</div>
          <div class="cs-stats-row">
            ${statsHTML}
          </div>
        </div>
      `;
    }

    const html = `
      <section class="cs-section" id="clinically-backed">
        <div class="cs-grid">
          <div class="cs-image-col">
            <img src="${PETRI_DISH_URL}" alt="Clinically backed formulation" class="cs-image" loading="lazy">
          </div>
          <div class="cs-copy-col">
            <h2 class="cs-intro">${data.intro}</h2>
            <p class="cs-paragraph">${data.paragraph}</p>
            ${categoriesHTML}
            <a href="#pdp-why-accordion" class="cs-cta">View Supplement Facts</a>
            <p class="cs-footnote"><sup class="cs-mark">*</sup>Based on clinical research on individual ingredients at studied dosages. Results may vary.</p>
          </div>
        </div>
      </section>
    `;

    return html;
  }

  function injectStyles() {
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .cs-section {
        background-color: #f5f3ee;
        padding: 80px 20px 20px;
      }

      .cs-grid {
        max-width: 1200px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: 45% 55%;
        gap: 60px;
        align-items: start;
      }

      .cs-image-col {
        display: flex;
        flex-direction: column;
      }

      .cs-image {
        width: 100%;
        border-radius: 12px;
        object-fit: cover;
        display: block;
      }

      .cs-copy-col {
        display: flex;
        flex-direction: column;
      }

      .cs-intro {
        font-family: 'Playfair Display', Georgia, serif;
        font-size: 30px;
        color: #1a1a1a;
        margin: 0 0 20px 0;
        line-height: 1.3;
        font-weight: 400;
      }

      .cs-intro em {
        font-style: italic;
        color: #2B4C3F;
      }

      .cs-paragraph {
        font-size: 15px;
        color: rgba(0, 0, 0, 0.55);
        line-height: 1.7;
        margin: 0 0 40px 0;
      }

      .cs-green {
        color: #2B4C3F;
        font-weight: 600;
      }

      .cs-category {
        margin-bottom: 0;
      }

      .cs-category-label {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 2px;
        color: #666;
        padding-top: 20px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        margin-top: 28px;
        margin-bottom: 24px;
      }

      .cs-category:first-of-type .cs-category-label {
        margin-top: 0;
      }

      .cs-stats-row {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        margin-bottom: 0;
      }

      .cs-stat {
        flex: 0 1 auto;
        min-width: 200px;
      }

      .cs-stat-number {
        font-size: 52px;
        font-weight: 400;
        color: #2b4c3f;
        margin-bottom: 6px;
        line-height: 1.1;
      }

      .cs-stat-desc {
        font-size: 14px;
        color: #555;
        line-height: 1.5;
        max-width: 280px;
      }

      .cs-cta {
        display: inline-block;
        border: 1px solid #2B4C3F;
        color: #2B4C3F;
        background-color: transparent;
        border-radius: 50px;
        padding: 12px 28px;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        cursor: pointer;
        margin-top: 40px;
        transition: all 0.3s ease;
      }

      .cs-cta:hover {
        background-color: #2B4C3F;
        color: white;
      }

      .cs-footnote {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.35);
        margin-top: 32px;
        margin-bottom: 0;
        line-height: 1.6;
      }

      .cs-mark {
        font-size: 0.6em;
        vertical-align: super;
        line-height: 0;
        color: #aaa;
        font-weight: 400;
      }

      .cs-fda-footer {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.4);
        margin-top: 12px;
        line-height: 1.6;
        text-align: center;
        max-width: 100%;
        padding: 0 20px;
      }

      @media (max-width: 768px) {
        .cs-grid {
          grid-template-columns: 1fr;
          gap: 40px;
        }

        .cs-intro {
          font-size: 24px;
        }

        .cs-paragraph {
          font-size: 14px;
          margin-bottom: 20px;
        }

        .cs-stat-number {
          font-size: 40px;
        }

        .cs-stats-row {
          gap: 30px;
        }

        .cs-stat {
          min-width: 160px;
        }

        .cs-category:first-child .cs-category-label {
          margin-top: 0;
          padding-top: 10px;
        }
      }
    `;

    document.head.appendChild(styleElement);
  }

  function handleCtaClick(e) {
    e.preventDefault();

    // Find the LAST .pdp-why-accordion-item (Active Ingredients)
    const accordionItems = document.querySelectorAll('.pdp-why-accordion-item');
    if (accordionItems.length === 0) return;

    const lastAccordionItem = accordionItems[accordionItems.length - 1];

    // Scroll to it smoothly with 80px offset for header
    const headerHeight = 80;
    const targetPosition = lastAccordionItem.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });

    // After 600ms delay, check if it needs to be opened
    setTimeout(function() {
      if (!lastAccordionItem.classList.contains('active')) {
        const headerButton = lastAccordionItem.querySelector('.pdp-why-accordion-header');
        if (headerButton) {
          headerButton.click();
        }
      }
    }, 600);
  }

  function injectFooterDisclaimer() {
    // Check if already injected
    if (document.querySelector('.cs-fda-footer')) {
      return;
    }

    // Find footer copyright paragraph
    const footerCopyright = document.querySelector('p.footer-copyright');
    if (!footerCopyright) {
      return;
    }

    // Create and insert FDA disclaimer paragraph
    const disclaimerPara = document.createElement('p');
    disclaimerPara.className = 'cs-fda-footer';
    disclaimerPara.textContent = '*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. Results based on published clinical research on individual ingredients at studied dosages. Individual results may vary.';

    footerCopyright.insertAdjacentElement('afterend', disclaimerPara);
  }

  function init() {
    // Check if product handle exists
    if (!window.ppuProductHandle) {
      return;
    }

    // Get copy key from handle
    const copyKey = getCopyKeyFromHandle(window.ppuProductHandle);
    if (!copyKey || !CLINICAL_DATA[copyKey]) {
      return;
    }

    // Inject styles
    injectStyles();

    // Build and inject section
    const data = CLINICAL_DATA[copyKey];
    const sectionHTML = buildSectionHTML(data);

    // Find insertion point
    const whyWorksSection = document.querySelector('section.pdp-why-works');
    if (!whyWorksSection) {
      return;
    }

    // Create a temporary container to hold the new section
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sectionHTML;
    const newSection = tempDiv.firstElementChild;

    // Insert after pdp-why-works
    whyWorksSection.insertAdjacentElement('afterend', newSection);

    // Add click handler to CTA
    const ctaButton = newSection.querySelector('.cs-cta');
    if (ctaButton) {
      ctaButton.addEventListener('click', handleCtaClick);
    }

    // Inject footer disclaimer
    injectFooterDisclaimer();
  }

  // Check if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }
})();
